// extracted by mini-css-extract-plugin
export var card = "_pz-0";
export var content = "_pz-2";
export var details = "_pz-3";
export var icon = "_pz-1";
export var iconBlue = "_pz-5";
export var iconBrand = "_pz-4";
export var iconGrayBlue = "_pz-6";
export var iconGreen = "_pz-7";
export var iconIndigo = "_pz-8";
export var iconOrange = "_pz-9";
export var iconPurple = "_pz-a";
export var iconRed = "_pz-b";
export var iconWarning = "_pz-c";